/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Switch, Route, useHistory } from "react-router-dom";

import Home from "./pages/Home";
import HomeGroup from "./pages/HomeGroup";
import GroupSelectYourSeat from "./pages/HomeGroup/pages/GroupSelectYourSeat/GroupSelectYourSeat";
import GroupSingleCheckout from "../TicketSingleGroup/pages/GroupSingleCheckout/GroupSingleCheckout";
import ByOpponent from "./pages/ByOpponent";
import ByGiveawayLanding from "./pages/ByGiveaway/ByGiveawayLanding";
import ByGiveaway from "./pages/ByGiveaway";
import ByDayOfWeek from "./pages/ByDayOfWeek";
import ByTimeOfDay from "./pages/ByTimeOfDay";
import ByTimeOfDayLanding from "./pages/ByTimeOfDay/ByTimeOfDayLanding";
import ByPrice from "./pages/ByPrice";
import GamesByOpponent from "./pages/ByOpponent/GamesByOpponent";
import ByPriceLanding from "./pages/ByPrice/ByPriceLanding";
import ByDayOfWeekLanding from "./pages/ByDayOfWeek/ByDayOfWeekLanding";
import { routePath } from "../../helpers/urlPathMapping";
import { adobePageNameTracking } from "../../helpers/tracking";
import { setCurrentPage } from "../../features/singleGroup/singleGroupSlice";
import { setType } from "../../features/singleGroup/singleGroupSlice";

const mainRoute = (type) => (
  <>
    <Route exact path={routePath(type).TICKET_SINGLE_GROUP.path}>
      <Home />
    </Route>
    <Route path={routePath(type).BY_OPPONENT.path}>
      <ByOpponent />
    </Route>
    <Route eaxct path={routePath(type).GAMES_BY_OPPONENT.path}>
      <GamesByOpponent />
    </Route>
    <Route path={routePath(type).BY_GIVEAWAY.path}>
      <ByGiveawayLanding />
    </Route>
    <Route path={routePath(type).GAMES_BY_GIVEAWAY.path}>
      <ByGiveaway />
    </Route>
    <Route path={routePath(type).BY_DAY_OF_WEEK.path}>
      <ByDayOfWeekLanding />
    </Route>
    <Route path={routePath(type).GAMES_BY_DAY_OF_WEEK.path}>
      <ByDayOfWeek />
    </Route>
    <Route path={routePath(type).BY_TIME_OF_DAY.path}>
      <ByTimeOfDayLanding />
    </Route>
    <Route path={routePath(type).GAMES_BY_TIME_OF_DAY.path}>
      <ByTimeOfDay />
    </Route>
    <Route path={routePath(type).BY_PRICE.path}>
      <ByPriceLanding />
    </Route>
    <Route path={routePath(type).GAMES_BY_PRICE.path}>
      <ByPrice />
    </Route>
  </>
);

const SingleTicketRoute = (type) => <Switch>{mainRoute(type)}</Switch>;

const GroupTicketRoute = (type) => {
  const {
    groupGameSelected,
    selectedMainSection,
    selectedSeatsNodes,
    sectionsAvailableSeats,
  } = useSelector((state) => state.singleGroup);
  const history = useHistory();
  //TODO: Remove this when launche
  // history.push("/");

  // useEffect(() => {}, [groupGameSelected]);
  return (
    <Switch>
      <Route exact path="/ticket-group-home">
        <HomeGroup />
      </Route>
      <Route path={routePath(type).GROUP_SELECT_YOUR_SEATS.path}>
        <GroupSelectYourSeat />
      </Route>
      {/* {console.log("groupGameSelected", groupGameSelected)} */}
      <Route path={routePath(type).TICKET_SINGLE_GROUP_CHECKOUT.path}>
        <GroupSingleCheckout
          selectedSeatsNodes={selectedSeatsNodes}
          groupGameSelected={groupGameSelected}
          selectedMainSection={selectedMainSection}
          sectionsAvailableSeats={sectionsAvailableSeats}
        />
      </Route>
      {mainRoute(type)}
      {/* "xa79PAlovb" */}
    </Switch>
  );
};
const TicketSingleGroup = () => {
  const { type } = useSelector((state) => state.singleGroup);

  const dispatch = useDispatch();
  const history = useHistory();

  //TODO:Remove this when launche
  // history.push("/");
  // useEffect(() => {
  //   // if()
  //   dispatch(setType("single"));
  //   console.log("here", history);
  // }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (!type) return;
      if (
        location.pathname !== "/" &&
        location.pathname !== "/ticket-single-group" &&
        location.pathname !== "/ticket-group-home" &&
        location.pathname !== "/ticket-single-group/group-select-your-seats" &&
        location.pathname !==
          "/ticket-single-group/ticket-single-group-checkout"
      ) {
        const routeObj = Object.keys(routePath(type))
          .map((key) => {
            if (routePath(type)[key].path === location.pathname) {
              return routePath(type)[key];
            }
            return null;
          })
          .filter(Boolean);
        dispatch(setCurrentPage(routeObj[0]?.title));
        // console.log("routeObj[0]", routeObj[0]);
        adobePageNameTracking({
          pageName: routeObj[0].pageName,
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, type]);
  return (
    <>
      {type === "single" ? (
        <SingleTicketRoute type={type} />
      ) : (
        <GroupTicketRoute type={type} />
      )}
    </>
  );
};

export default TicketSingleGroup;
